import React from 'react';
import './App.css';
import Body from './Components/Body/Body';
import Footer from './Components/Footer/Footer';

function App() {
  return (
    <div className="app">
     <Body />
     <Footer />
    </div>
  );
}

export default App;
